import { Suspense } from 'react';
import { useMatches, useOutlet, useNavigation } from 'react-router';

import { Box, LoadingOverlay } from '@mantine/core';

import { AuthProvider } from 'context/AuthProvider';
import { HeadquarterProvider } from 'context/HeadquarterContext';
import { PusherProvider } from 'context/PusherProvider';
import { CubohActionBarProvider } from 'context/CubohActionBarProvider';
import { ScopesProvider } from 'context/ScopesProvider';
import { IntercomProvider } from 'context/IntercomProvider';
import { RouteLoadingContext } from 'context/RouteLoadingContext';

import ErrorBoundary from 'errorBoundary/ErrorBoundary';
import { PendoProvider } from 'components/PendoProvider';
import { MParticleSharedAttributesSync } from 'hooks/useMParticleSharedAttributes';
import { PageViewTracker } from 'components/PageViewTracker';

export default function Layout() {
  const { state } = useNavigation();
  const matches = useMatches();
  const outlet = useOutlet();

  const isRouteLoading = state === 'loading';
  const ownsRouteLoader = matches.some(match => match.handle?.ownsRouteLoader);

  return (
    <ErrorBoundary rootErrorBoundary>
      {/* ^ this ErrorBoundary is for errors that happen in the
          Providers between this and the second ErrorBoundary below */}
      <PusherProvider>
        <AuthProvider>
          <IntercomProvider>
            {/* TODO: move headquarter provider to protected layout */}
            <ErrorBoundary rootErrorBoundary>
              {/* ^ this ErrorBoundary is for the rest of the app so that it can use the
                  AuthContext to provide a Go to Login button for the user */}
              <HeadquarterProvider>
                <PendoProvider />
                <MParticleSharedAttributesSync />
                <PageViewTracker />
                <CubohActionBarProvider>
                  <ScopesProvider>
                    {/* overlay rather than replace the outlet, so lazy route loads
                        don't tear down the providers above */}
                    <Box pos="relative">
                      <LoadingOverlay visible={isRouteLoading && !ownsRouteLoader} />
                      <RouteLoadingContext.Provider value={isRouteLoading}>
                        <Suspense>{outlet}</Suspense>
                      </RouteLoadingContext.Provider>
                    </Box>
                  </ScopesProvider>
                </CubohActionBarProvider>
              </HeadquarterProvider>
            </ErrorBoundary>
          </IntercomProvider>
        </AuthProvider>
      </PusherProvider>
    </ErrorBoundary>
  );
}
